<script>
import MainContainer from '@/components/main/MainContainer.vue'
import UiHead from '@/components/UI/atoms/UiHead.vue'

const maxHeight = 153

export default {
	name: 'FishListPercentage',
	components: {
		MainContainer,
		UiHead,
	},
	props: {
		fishTop: Array,
	},
	data() {
		return {
			isMouseEnter: false,
		}
	},
	computed: {
		getMaxPercentage() {
			return this.fishTop.reduce((max, fish) => {
				if (fish.percentage > max) {
					return fish.percentage
				}
				return max
			}, 0)
		},
		getMaxHeight() {
			return (this.getMaxPercentage * maxHeight) / 100 + 235
		},
		getHeight() {
			return (percent) => {
				return (maxHeight * percent) / 100
			}
		},
		getMarginBottomStyle() {
			return (percent) => {
				return {
					marginBottom: `${(100 - percent) / 4 + 15}px`,
				}
			}
		},
	},
	methods: {
		mouseEnter() {
			this.isMouseEnter = true
		},
		mouseLeave() {
			this.isMouseEnter = false
		},
	},
}
</script>

<template>
	<section id="fishStat" v-show="fishTop.length" class="pb-[20px] lg:py-[40px]">
		<MainContainer class="relative">
			<div class="mb-[40px] md:mb-[60px]">
				<UiHead>
					{{ $t('titles.FishListPercentage') }}
				</UiHead>
			</div>
			<div
				class="w-full relative px-[20px] md:px-[40px] lg:px-[60px] rounded-[45px] overflow-y-auto"
				@mouseenter="mouseEnter"
				@mouseleave="mouseLeave"
			>
				<div class="absolute bottom-0 left-0 w-full h-full min-w-[1100px] overflow-hidden">
					<img
						src="@/assets/img/main/wave-3.svg"
						alt=""
						:class="{
							'rotate-2': isMouseEnter,
						}"
						class="absolute bottom-0 left-0 w-full transform translate-x-[0%] duration-300 delay-0"
					/>
					<img
						src="@/assets/img/main/wave-2.svg"
						alt=""
						:class="{
							'-translate-x-10': isMouseEnter,
						}"
						class="absolute bottom-[25%] left-0 w-full transform translate-x-[0%] duration-300"
					/>
					<img
						src="@/assets/img/main/wave-1.svg"
						alt=""
						:class="{
							'scale-y-150 delay-0': isMouseEnter,
						}"
						class="absolute bottom-0 left-0 w-full transform translate-x-[0%] duration-300 delay-150"
					/>
				</div>
				<div
					:style="{
						height: `${getMaxHeight}px`,
					}"
					class="relative z-1 flex justify-between items-end gap-2 min-w-[1000px]"
				>
					<div
						v-for="fish in fishTop"
						:key="fish.id"
						:style="getMarginBottomStyle(fish.percentage)"
						class="group flex flex-col items-center gap-2"
					>
						<span
							class="font-main font-extrabold text-[26px] text-[#fc792d] leading-5 whitespace-nowrap duration-700 group-hover:-translate-y-10"
							>{{ `${fish.percentage} %` }}</span
						>
						<span
							class="font-main font-light text-[14px] text-second py-1 px-2 bg-[#E6F3FE] rounded-[15px] duration-700 group-hover:-translate-y-10"
							>{{ fish.title }}</span
						>
						<div
							:style="{
								height: `${getHeight(fish.percentage)}px`,
							}"
							class="grow border-l border-dashed border-l-main duration-700 group-hover:scale-y-150 group-hover:-translate-y-5"
						></div>
						<img
							src="@/assets/svgs/fish.svg"
							alt=""
							class="block transform origin-left duration-700 group-hover:-rotate-12"
						/>
					</div>
				</div>
			</div>
		</MainContainer>
	</section>
</template>

<style scoped></style>
